/**
 * Created by tofael on 3/22/17.
 */

import actions from './types';

export function setUser(data) {

  const action ={
    type: actions.SET_USER,
    data
  }

  return action;
}

export function destroyUser() {

  const action ={
    type: actions.DESTROY_USER,
  }

  return action;
}



// WEBPACK FOOTER //
// ./src/actions/user.js